class NewsletterForm extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.setupEventListeners()
    this.createSuccessMessage()
  }

  createSuccessMessage() {
    const successMessage = document.createElement('div')
    successMessage.className = 'success-message'
    successMessage.style.cssText = 'display: none; color: #009875; margin-top: 8px;'
    successMessage.classList.add('paragraph-md')
    successMessage.textContent = this.dataset.thankYouMessage
    this.appendChild(successMessage)
  }

  setupEventListeners() {
    const submitButton = this.querySelector('button[type="submit"]')
    if (submitButton) {
      submitButton.addEventListener('click', e => {
        e.preventDefault()
        const emailInput = this.querySelector('input[type="email"]')
        if (emailInput && this.isValidEmail(emailInput.value)) {
          const cf7Submit = this.querySelector('.newsletter-submit')
          if (cf7Submit) {
            cf7Submit.click()
            this.showSuccessMessage()
          }
        }
      })
    }
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  showSuccessMessage() {
    const successMessage = this.querySelector('.success-message')
    if (successMessage) {
      successMessage.style.display = 'block'
      setTimeout(() => {
        successMessage.style.display = 'none'
      }, 5000)
    }
  }
}

if (!customElements.get('newsletter-form')) {
  customElements.define('newsletter-form', NewsletterForm)
}
